<template>
  <div class="avatar">
    <div class="wrap">
      <img :src="getImage" @error="onImageLoadError" />
    </div>
  </div>
</template>

<script type="text/babel">
  export default {
    props: {
      username: { type: String, required: true },
      initials: { type: String, default: null },
      size: { type: Number, default: 280 },
      src: { type: String, default: null },
      rounded: { type: Boolean, default: true },
    },

    data() {
      return {
        avatar: this.src,
      };
    },

    computed: {
      userInitial() {
        return this.initials || this.initial(this.username);
      },

      getImage() {
        if (this.avatar) {
          return this.avatar;
        } else {
          return this.getDataURI(this.username, this.size);
        }
      },
    },

    mounted() {
      this.$emit('avatar-initials', this.username, this.userInitial);
    },

    methods: {
      initial(username) {
        let parts = username.split(/[ -]/);
        let initials = '';

        for (let i = 0; i < parts.length; i++) {
          initials += parts[i].charAt(0);
        }

        if (initials.length > 3 && initials.search(/[A-Z]/) !== -1) {
          initials = initials.replace(/[a-z]+/g, '');
        }

        initials = initials.substr(0, 3).toUpperCase();

        return initials;
      },

      getDataURI: function (name, size) {
        name = name || '';
        size = size || 60;

        let colours = [
            '#1abc9c',
            '#2ecc71',
            '#3498db',
            '#9b59b6',
            '#34495e',
            '#16a085',
            '#27ae60',
            '#2980b9',
            '#8e44ad',
            '#2c3e50',
            '#f1c40f',
            '#e67e22',
            '#e74c3c',
            '#ecf0f1',
            '#95a5a6',
            '#f39c12',
            '#d35400',
            '#c0392b',
            '#bdc3c7',
            '#7f8c8d',
          ],
          nameSplit = String(name).toUpperCase().split(' '),
          charCodeSum = name
            .split('')
            .map((c) => {
              return c.charCodeAt(0);
            })
            .reduce((a, b) => a + b, 0);

        let initials, charIndex, colourIndex, canvas, context, dataURI;

        if (nameSplit.length === 1) {
          initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
        } else {
          initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
        }

        if (window.devicePixelRatio) {
          size = size * window.devicePixelRatio;
        }

        charIndex = (initials === '?' ? 72 : charCodeSum) - 64;
        colourIndex = charIndex % colours.length;
        canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        context = canvas.getContext('2d');
        context.fillStyle = colours[colourIndex];
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.font = 'bold ' + Math.round(canvas.width / 2) + 'px "Source Sans Pro"';
        context.textAlign = 'center';
        context.fillStyle = '#FFF';
        context.fillText(initials, size / 2, size / 1.5);
        dataURI = canvas.toDataURL();
        canvas = null;

        return dataURI;
      },

      /**
       * Handle error image load (set to initial avatar username)
       */
      onImageLoadError() {
        this.avatar = undefined;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .avatar {
    position: relative;
    display: inline-block;
    min-width: 32px;

    &--rounded {
      .wrap {
        border-radius: 100%;
      }
    }

    .wrap {
      display: block;
      position: relative;
      width: 100%;
      padding-bottom: 100%;
      overflow: hidden;
      background: #f5f5f5;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }
</style>
